import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommTagOutlineAltIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M15.25 6.50023C15.25 7.74287 16.2574 8.75023 17.5 8.75023C18.7427 8.75023 19.75 7.74287 19.75 6.50023C19.75 5.25759 18.7427 4.25023 17.5 4.25023C16.2574 4.25023 15.25 5.25759 15.25 6.50023ZM17.5 7.25023C17.0858 7.25023 16.75 6.91445 16.75 6.50023C16.75 6.08602 17.0858 5.75023 17.5 5.75023C17.9143 5.75023 18.25 6.08602 18.25 6.50023C18.25 6.91445 17.9143 7.25023 17.5 7.25023Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M7.53037 13.4699C7.23748 13.177 6.76261 13.177 6.46971 13.4699C6.17682 13.7628 6.17682 14.2377 6.46971 14.5306L9.46971 17.5306C9.76261 17.8235 10.2375 17.8235 10.5304 17.5306C10.8233 17.2377 10.8233 16.7628 10.5304 16.4699L7.53037 13.4699Z"
            fill="#222"
          />
          <path
            d="M19.4595 1.57208C20.2082 1.74402 20.9664 2.0252 21.4706 2.5294C21.9748 3.0336 22.256 3.79184 22.4279 4.54046C22.6055 5.3138 22.6927 6.19907 22.7288 7.06907C22.8011 8.81159 22.6717 10.5921 22.5881 11.5022C22.5359 12.0702 22.3036 12.5946 21.9407 13.0168C19.2314 16.1691 16.4229 19.0388 13.3564 21.7845C11.9533 23.0408 9.85831 23.0541 8.39718 21.9228C5.9875 20.0571 3.94289 18.0125 2.07715 15.6028C0.94585 14.1417 0.959175 12.0467 2.21549 10.6436C4.96116 7.57712 7.83088 4.76863 10.9832 2.05931C11.4054 1.69644 11.9298 1.46409 12.4978 1.4119C13.4079 1.32827 15.1884 1.19887 16.9309 1.27116C17.8009 1.30726 18.6862 1.39446 19.4595 1.57208ZM16.8688 2.76987C15.2245 2.70166 13.5206 2.82424 12.635 2.90561C12.3908 2.92804 12.1572 3.0282 11.9609 3.19689C8.85739 5.86426 6.03447 8.62707 3.333 11.6442C2.58302 12.4818 2.55318 13.7675 3.2632 14.6845C5.05136 16.994 7.006 18.9486 9.3155 20.7368C10.2325 21.4468 11.5182 21.417 12.3558 20.667C15.3729 17.9655 18.1357 15.1426 20.8031 12.0391C20.9718 11.8428 21.072 11.6092 21.0944 11.365C21.1758 10.4794 21.2983 8.77552 21.2301 7.13124C21.196 6.30784 21.1148 5.52413 20.966 4.87623C20.8115 4.2036 20.6082 3.78832 20.4099 3.59006C20.2117 3.3918 19.7964 3.1885 19.1238 3.03401C18.4759 2.88521 17.6922 2.80403 16.8688 2.76987Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
